<template>
  <b-modal
    :id="id"
    :title="title | i18n"
    hide-footer
    size="lg"
    centered
    content-class="rounded-8"
    @close="clear"
    @show="show"
    @hide="hide"
  >
    <div class="row">
      <!-- fake inputs for disable autocomplite -->
      <div class="fake-inputs">
        <input id="username" type="text" name="fakeusernameremembered" />
        <input id="password" type="password" name="fakepasswordremembered" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="data.username" form-group-id="name" placeholder="name" customID="Name" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input
          v-model="data.email"
          form-group-id="email"
          placeholder="email"
          autocomplete="off"
          type="email"
          :update-error="updateError"
          customID="Email"
        />
      </div>
      <!-- <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="data.group" form-group-id="group" placeholder="Group" />
      </div> -->
      <!-- <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="data.company" form-group-id="company" placeholder="Company" />
      </div> -->
      <!-- <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="data.operatingSites" form-group-id="operatingSites" placeholder="Operating Sites" />
      </div> -->
      <div v-if="showPassword" class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Input
          v-model="data.password"
          form-group-id="password-actual"
          placeholder="password"
          type="password"
          autocomplete="off"
          customID="Password"
        />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Select v-model="data.team" :options="teamOptions" form-group-id="team" placeholder="Team" customID="Team" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Select v-model="data.role" :options="rolesOptions" form-group-id="user_role" placeholder="user_role" customID="Role" />
      </div>
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between">
        <b-button variant="outline-secondary" size="lg" class="btn-delete-device mr-3 px-125" @click="close">
          {{ 'Close' | i18n }}
        </b-button>
        <b-button
          id="submit"
          variant="outline-primary"
          size="lg"
          class="btn-delete-device px-125"
          :disabled="isError"
          @click="onSubmit"
        >
          {{ 'Save' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from '../../common/input';
import Select from '../../common/select';
import Checkbox from '../../common/checkbox';
import { UserMixin, NotificationMixin, LicenseMixin, ReportsMixin, AuthMixin } from '../../../../mixins';
import { ROLES, ROLES_NAMES } from '../../../../../../../constants';

export default {
  title: 'Add team',
  components: { Input, Select, Checkbox },
  mixins: [UserMixin, NotificationMixin, LicenseMixin, ReportsMixin, AuthMixin],
  props: {
    getPage: {
      type: Function,
      default: () => {},
    },
    submit: {
      type: Function,
      default: () => {},
    },
    title: {
      type: String,
      default: () => '',
    },
    id: {
      type: String,
      default: () => '',
    },
    type: {
      type: String,
      default: () => '',
    },
    init: {
      type: Object,
      default: () => {},
    },
    showPassword: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      preventCloseLocal: true,
      data: {
        role: ROLES.USER,
      },
      rolesOptions: Object.values(ROLES)
        .filter((v) => v !== 'superadmin')
        .map((v) => ({
          value: v,
          text: this.$translate(ROLES_NAMES[v]),
        })),
      inputError: false,
      initDataForCheck: {},
      teams: [],
    };
  },
  computed: {
    teamOptions: function () {
      return this.teams.map((item) => ({ value: item.id, text: item.name }));
    },
    isError: function () {
      let isModified = false;
      Object.keys(this.data).map((key) => {
        if (this.data[key] !== this.initDataForCheck[key]) {
          isModified = true;
        }
      });
      return (!this.data.username && !this.data.email) || !this.data.password || !this.data.role || this.inputError || !isModified;
    },
  },
  methods: {
    async show() {
      this.preventCloseLocal = true;
      if (this.init) {
        this.data = Object.assign({}, this.init);
        if (!this.showPassword) {
          this.data.password = true;
        }
        this.initDataForCheck = Object.assign({}, this.data);
      }
      const response = await this.reportsService.getTeams();
      this.teams = response;

      if (this.isSuperadmin) {
        this.rolesOptions = [
          {
            value: 'superadmin',
            text: this.$translate(ROLES_NAMES.superadmin),
          },
          ...this.rolesOptions,
        ];
      }
    },
    updateError(e) {
      this.inputError = e;
    },
    clear() {
      this.teams = [];
      this.data = {};
    },
    close() {
      this.$root.$emit('bv::hide::modal', this.id);
    },
    hide(e) {
      let isModified = true;
      this.rolesOptions = Object.values(ROLES)
        .filter((v) => v !== 'superadmin')
        .map((v) => ({
          value: v,
          text: this.$translate(ROLES_NAMES[v]),
        }));

      if (this.type === 'add') {
        const length = Object.keys(this.data).length;
        if (!length) {
          isModified = false;
        }
      }

      if (this.type === 'edit') {
        isModified = false;
        Object.keys(this.data).map((key) => {
          if (this.data[key] !== this.initDataForCheck[key]) {
            isModified = true;
          }
        });
      }
      if (this.preventCloseLocal && isModified) {
        let message = confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
        if (!message) {
          return e.preventDefault();
        }
        this.clear();
      }
    },
    async onSubmit() {
      try {
        this.preventCloseLocal = false;
        const { email, password, role, username, group, company, operatingSites, team } = this.data;
        await this.submit({ email, password, role: role, username, group, company, operatingSites, team }, this.init);
        this.$root.$emit('bv::hide::modal', this.id);
        this.clear();
        await this.getPage();
        this.showNotification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        console.log(err, 'err');
        this.showNotification({ type: 'error', message: err.message });
        this.preventCloseLocal = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #add-team .modal-dialog {
  max-width: 700px !important;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.fake-inputs {
  position: absolute;
  z-index: -10;
  top: -500;
  opacity: 0;
}

.px-125 {
  padding-left: 125px;
  padding-right: 125px;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
